import { Link } from 'react-router-dom';
import { COMPLETE } from '../constants/content';
import TopBar from '../components/TopBar';

export default function CompletePage() {
  return (
    <div className="page page--panel">
      <TopBar />
      <main className="panel">
        <div className="panel__card complete-card">
          <div className="complete-card__check" aria-hidden="true">
            ✓
          </div>
          <p className="panel__eyebrow">Done</p>
          <h1>{COMPLETE.title}</h1>
          <p className="complete-card__lead">{COMPLETE.lead}</p>

          <ul className="complete-card__tips">
            {COMPLETE.tips.map((tip) => (
              <li key={tip}>{tip}</li>
            ))}
          </ul>

          <section className="complete-card__help" aria-labelledby="help-heading">
            <h2 id="help-heading">{COMPLETE.contactTitle}</h2>
            <p>{COMPLETE.contactBody}</p>
          </section>

          <p className="complete-card__back">
            <Link to="/">Return home</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
